// DTOs mirrored from Scout.Api PasswordEndpoints.

/** What a person sends to change their own password. Both fields are required by the API. */
export interface ChangePasswordBody {
  currentPassword: string
  newPassword: string
}

/**
 * The answer to an admin's reset. `temporaryPassword` exists in readable form exactly here, exactly
 * once: the API stores only its hash and never logs it, so a screen that loses it cannot get it back —
 * only mint another. Never put it in a query cache, a URL or an error message.
 */
export interface PasswordReset {
  userId: string
  temporaryPassword: string
}

/** The floor the API enforces, repeated here only so the form can say it before the round trip. */
export const MINIMUM_PASSWORD_LENGTH = 12
